import { render } from "./OrderList.vue?vue&type=template&id=47c368ce&scoped=true"
import script from "./OrderList.vue?vue&type=script&lang=js"
export * from "./OrderList.vue?vue&type=script&lang=js"

import "./OrderList.vue?vue&type=style&index=0&id=47c368ce&scoped=true&lang=css"
import "./OrderList.vue?vue&type=style&index=1&id=47c368ce&lang=css"

import exportComponent from "C:\\laragon\\www\\bdroyelculture-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47c368ce"]])

export default __exports__